import { Close } from '@mui/icons-material';
import { ModalWrapper } from 'common/components/ModalWrapper';
import { darkNavy } from 'common/styles/colors';
import { FC } from 'react';
import {
  BodyWrapper,
  ButtonDiv,
  CancelButton,
  HeaderWrapper,
  TitleDiv,
} from './styles';

interface ModalProps {
  redirect: () => void;
  isOpen: boolean;
  closeModal: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export const EditPickPlanModal: FC<ModalProps> = ({
  redirect,
  isOpen,
  closeModal,
}) => {
  const Header: FC = () => (
    <HeaderWrapper>
      <TitleDiv>Edit Pick Plan</TitleDiv>
      <CancelButton type='button' onClick={closeModal}>
        <span>Cancel</span>
        <Close />
      </CancelButton>
    </HeaderWrapper>
  );

  const Body: FC = () => (
    <BodyWrapper>
      <ButtonDiv>
        <button type='button' onClick={closeModal}>
          <span>EDIT BIN REQUEST</span>
        </button>
        <button type='button' onClick={redirect}>
          <span>SCHEDULE BLOCKS</span>
        </button>
      </ButtonDiv>
    </BodyWrapper>
  );

  return (
    <ModalWrapper
      isOpen={isOpen}
      backgroundColor={darkNavy}
      closeModal={closeModal}
      header={<Header />}
      body={<Body />}
    />
  );
};
